export default "__VITE_ASSET___kvc4Xdv__"